import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { DxChartComponent, DxPieChartComponent, DxPivotGridComponent } from 'devextreme-angular';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { exportWidgets } from 'devextreme/viz/export';
import { Workbook } from 'exceljs';
import { O2ReportFiltersComponent } from '../o2-report-filters.component';
import saveAs from 'file-saver';
@Component({
  selector: 'app-o2-portal-asu-awards-by-competitor',
  templateUrl: './o2-portal-asu-awards-by-competitor.component.html',
  styleUrls: ['./o2-portal-asu-awards-by-competitor.component.scss']
})
export class O2PortalAsuAwardsByCompetitorComponent implements AfterViewInit {

  isLoadPanelVisible: boolean = false;
  totalGaseousOxygen = 0;
  totalAllBusinessGaseousOxygenText = "";
  totalSOGBusinessGaseousOxygenText = "";
  totalSOEBusinessGaseousOxygenText = "";

  o2PortalAwardsByCompetitorData: any;
  allBusinessPieChartData: any;
  sOGBusinessPieChartData: any;
  sOEBusinessPieChartData: any;
  allBusinessBarChartData: any;
  sOGBusinessBarChartData: any;
  sOEBusinessBarChartData: any;
  fromDate: any;
  toDate: any;

  pivotGridRegionAndCompititorDataSource: any;
  pivotGridProcessAndCompititorDataSource: any;
  pivotGridApplicationAndCompititorDataSource: any;
  pivotGridASUNominalCapacityAndCompititorDataSource: any;
  resolveOverlappingTypes = ['shift', 'hide', 'none'];
  allBusinessColors: Map<string, string>;
  sOGBusinessColors: Map<string, string>;
  sOEBusinessColors: Map<string, string>;
  @ViewChild(O2ReportFiltersComponent) reportFilter;
  @ViewChild("dxAllBusinessBarChart", { static: false }) dxAllBusinessBarChart: DxChartComponent;
  @ViewChild("dxSOGBusinessBarChart", { static: false }) dxSOGBusinessBarChart: DxChartComponent;
  @ViewChild("dxSOEBusinessBarChart", { static: false }) dxSOEBusinessBarChart: DxChartComponent;
  @ViewChild("dxAllBusinessPieChart", { static: false }) dxAllBusinessPieChart: DxPieChartComponent;
  @ViewChild("dxSOGBusinessPieChart", { static: false }) dxSOGBusinessPieChart: DxPieChartComponent;
  @ViewChild("dxSOEBusinessPieChart", { static: false }) dxSOEBusinessPieChart: DxPieChartComponent;
  @ViewChild('VolumeAnalysisByRegionAndCompetitor', { static: false }) regionAndCompititorGrid: DxPivotGridComponent;
  @ViewChild('VolumeAnalysisByProcessAndCompetitor', { static: false }) processAndCompetitorGrid: DxPivotGridComponent;
  @ViewChild('VolumeAnalysisByApplicationAndCompetitor', { static: false }) applicationAndCompetitorGrid: DxPivotGridComponent;
  @ViewChild('VolumeAnalysisByASUNominalCapacityAndCompetitor', { static: false }) aSUNominalCapacityAndCompetitorGrid: DxPivotGridComponent;
  constructor() {
    this.customizeAllBusinessLabel = this.customizeAllBusinessLabel.bind(this);
    this.customizeSOGBusinessLabel = this.customizeSOGBusinessLabel.bind(this);
    this.customizeSOEBusinessLabel = this.customizeSOEBusinessLabel.bind(this);
    this.allBusinessColors = new Map<string, string>();
    this.sOGBusinessColors = new Map<string, string>();
    this.sOEBusinessColors = new Map<string, string>();
  }

  ngAfterViewInit() {
    this.dxAllBusinessBarChart.instance.render();
    this.dxSOGBusinessBarChart.instance.render();
    this.dxSOEBusinessBarChart.instance.render();
  }
  getO2PortalAwardsByCompetitor(o2PortalAwardsData) {
    this.o2PortalAwardsByCompetitorData = o2PortalAwardsData;
    this.isLoadPanelVisible = false;
    this.fromDate = this.reportFilter.fromDate.getFullYear();
    this.toDate = this.reportFilter.toDate.getFullYear();
    this.allBusinessColors.clear();
    this.sOGBusinessColors.clear();
    this.sOEBusinessColors.clear();
    this.setDataSources();
  }
  setDataSources() {
    // All Business - PieChart
    this.totalGaseousOxygen = 0;
    this.o2PortalAwardsByCompetitorData.sort((a, b) => { return a.topCompetitors.localeCompare(b.topCompetitors) });
    let allArrayData = this.o2PortalAwardsByCompetitorData.map(item => {
      this.totalGaseousOxygen = this.totalGaseousOxygen + item.totalOxygen;
      return item;
    });
    this.totalAllBusinessGaseousOxygenText = this.getGaseousOxygenText();
    allArrayData = allArrayData.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.topCompetitors === item.topCompetitors)
      if (accItem) {
        accItem.gaseousOxygen = Math.round(accItem.gaseousOxygen + item.gaseousOxygen);
      } else {
        accm.push(item)
      }
      return accm;
    }, []);

    let totalCountArray = [...allArrayData].map(item => ({ ...item }));
    let totalCount = totalCountArray.reduce((prevValue, item) => Math.round(prevValue + item.gaseousOxygen), 0);

    this.allBusinessPieChartData = allArrayData.map((item, index) => {
      let cumulativeCount = item.gaseousOxygen;
      return {
        topCompetitors: item.topCompetitors,
        cumulativePercent: Math.round(cumulativeCount * 100 / totalCount),
      };
    });

    // All Business - Bar Chart
    this.allBusinessBarChartData = [... this.o2PortalAwardsByCompetitorData].map(item => ({ ...item }));
    this.allBusinessBarChartData.sort((a, b) => {
      if (a.awardYear > b.awardYear) {
        return 1;
      }

      if (a.awardYear < b.awardYear) {
        return -1;
      }

      return 0;
    });
    this.allBusinessBarChartData = this.allBusinessBarChartData.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.topCompetitors === item.topCompetitors && ai.awardYear === item.awardYear)
      if (accItem) {
        accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen);
        // To remove comma from long datatype field = converted to string
        accItem.awardYear = accItem.awardYear.toString()
      } else {
        item.awardYear = item.awardYear.toString()
        accm.push(item)
      }

      return accm;
    }, []);

    //-------------------------------------
    // SOG Business - PieChart
    this.totalGaseousOxygen = 0;
    let sOGArrayData = this.o2PortalAwardsByCompetitorData.filter(item => {
      if (item.businessModel == 'SOG') {
        this.totalGaseousOxygen = this.totalGaseousOxygen + item.totalOxygen;
        return item;
      }
    }).map(x => { return x; });
    this.totalSOGBusinessGaseousOxygenText = this.getGaseousOxygenText();
    sOGArrayData = sOGArrayData.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.topCompetitors === item.topCompetitors)
      if (accItem) {
        accItem.gaseousOxygen = Math.round(accItem.gaseousOxygen + item.gaseousOxygen);
      } else {
        accm.push(item)
      }
      return accm;
    }, []);

    totalCountArray = [...sOGArrayData].map(item => ({ ...item }));
    totalCount = totalCountArray.reduce((prevValue, item) => Math.round(prevValue + item.gaseousOxygen), 0);

    this.sOGBusinessPieChartData = sOGArrayData.map((item, index) => {
      let cumulativeCount = item.gaseousOxygen;
      return {
        topCompetitors: item.topCompetitors,
        cumulativePercent: Math.round(cumulativeCount * 100 / totalCount),
      };
    });

    // SOG Business - Bar Chart
    this.sOGBusinessBarChartData = this.o2PortalAwardsByCompetitorData.filter(item => {
      if (item.businessModel == 'SOG') {
        return item;
      }
    }).map(x => { return x; });
    this.sOGBusinessBarChartData.sort((a, b) => {
      if (a.awardYear > b.awardYear) {
        return 1;
      }

      if (a.awardYear < b.awardYear) {
        return -1;
      }

      return 0;
    });
    this.sOGBusinessBarChartData = this.sOGBusinessBarChartData.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.topCompetitors === item.topCompetitors && ai.awardYear === item.awardYear)
      if (accItem) {
        accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen);
        // To remove comma from long datatype field = converted to string
        accItem.awardYear = accItem.awardYear.toString()
      } else {
        item.awardYear = item.awardYear.toString()
        accm.push(item)
      }

      return accm;
    }, []);

    //-------------------------------------
    // SOE Business - PieChart
    this.totalGaseousOxygen = 0;
    let sOEArrayData = this.o2PortalAwardsByCompetitorData.filter(item => {
      if (item.businessModel == 'SOE') {
        this.totalGaseousOxygen = this.totalGaseousOxygen + item.totalOxygen;
        return item;
      }
    }).map(x => { return x; });
    this.totalSOEBusinessGaseousOxygenText = this.getGaseousOxygenText();
    sOEArrayData = sOEArrayData.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.topCompetitors === item.topCompetitors)
      if (accItem) {
        accItem.gaseousOxygen = Math.round(accItem.gaseousOxygen + item.gaseousOxygen);
      } else {
        accm.push(item)
      }
      return accm;
    }, []);

    totalCountArray = [...sOEArrayData].map(item => ({ ...item }));
    totalCount = totalCountArray.reduce((prevValue, item) => Math.round(prevValue + item.gaseousOxygen), 0);
    this.sOEBusinessPieChartData = sOEArrayData.map((item, index) => {
      let cumulativeCount = item.gaseousOxygen;
      return {
        topCompetitors: item.topCompetitors,
        cumulativePercent: Math.round(cumulativeCount * 100 / totalCount),
      };
    });

    // SOE Business - Bar Chart
    this.sOEBusinessBarChartData = this.o2PortalAwardsByCompetitorData.filter(item => {
      if (item.businessModel == 'SOE') {
        return item;
      }
    }).map(x => { return x; });
    this.sOEBusinessBarChartData.sort((a, b) => {
      if (a.awardYear > b.awardYear) {
        return 1;
      }

      if (a.awardYear < b.awardYear) {
        return -1;
      }

      return 0;
    });
    this.sOEBusinessBarChartData = this.sOEBusinessBarChartData.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.topCompetitors === item.topCompetitors && ai.awardYear === item.awardYear)
      if (accItem) {
        accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen);
        // To remove comma from long datatype field = converted to string
        accItem.awardYear = accItem.awardYear.toString()
      } else {
        item.awardYear = item.awardYear.toString()
        accm.push(item)
      }

      return accm;
    }, []);
    //-------------------------------------
    this.pivotGridRegionAndCompititorDataSource = {
      fields: [{
        caption: 'Competitors',
        width: 120,
        dataField: 'topCompetitors',
        area: 'row',
      }, {
        dataField: 'lasuregions',
        area: 'column',
      }, {
        groupName: 'topCompetitors',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'totalOxygen',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.o2PortalAwardsByCompetitorData
    }

    this.pivotGridProcessAndCompititorDataSource = {
      fields: [{
        caption: 'Competitors',
        width: 120,
        dataField: 'topCompetitors',
        area: 'row',
      }, {
        dataField: 'process',
        area: 'column',
      }, {
        groupName: 'topCompetitors',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'totalOxygen',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.o2PortalAwardsByCompetitorData
    }

    this.pivotGridApplicationAndCompititorDataSource = {
      fields: [{
        caption: 'Competitors',
        width: 120,
        dataField: 'topCompetitors',
        area: 'row',
      }, {
        dataField: 'application',
        area: 'column',
      }, {
        groupName: 'topCompetitors',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'totalOxygen',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.o2PortalAwardsByCompetitorData
    }

    this.pivotGridASUNominalCapacityAndCompititorDataSource = {
      fields: [{
        caption: 'Competitors',
        width: 120,
        dataField: 'topCompetitors',
        area: 'row',
      }, {
        dataField: 'asunominalCapacity',
        area: 'column',
      }, {
        groupName: 'topCompetitors',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'totalOxygen',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.o2PortalAwardsByCompetitorData
    }
  }
  onCellPrepared(e) {
    if (e.area === "data" && e.cell.text === "") {
      e.cellElement.textContent = "0";
    }
  }
  getGaseousOxygenText() {
    return this.totalGaseousOxygen.toLocaleString('en-IN') + ' mtpd';
  }
  exportCharts() {
    const dxAllBusinessPieChartInstance = this.dxAllBusinessPieChart.instance;
    const dxSOGBusinessPieChartInstance = this.dxSOGBusinessPieChart.instance;
    const dxSOEBusinessPieChartInstance = this.dxSOEBusinessPieChart.instance;
    const dxAllBusinessBarChartInstance = this.dxAllBusinessBarChart.instance;
    const dxSOGBusinessBarChartInstance = this.dxSOGBusinessBarChart.instance;
    const dxSOEBusinessBarChartInstance = this.dxSOEBusinessBarChart.instance;

    exportWidgets([[dxAllBusinessPieChartInstance, dxAllBusinessBarChartInstance],
    [dxSOGBusinessPieChartInstance, dxSOGBusinessBarChartInstance],
    [dxSOEBusinessPieChartInstance, dxSOEBusinessBarChartInstance]], {
      fileName: "ASUAwards_ByCompetitor_ChartReport",
      format: "PNG"
    });
  }
  exportExcel(e) {
    const context = this;
    const workbook = new Workbook();
    const regionWorkSheet = workbook.addWorksheet("Region & Competitor");
    const processWorkSheet = workbook.addWorksheet("Process & Competitor");
    const applicationWorkSheet = workbook.addWorksheet("Application & Competitor");
    const asuCapacityWorkSheet = workbook.addWorksheet("ASU Nominal Capacity & Competitor");

    exportPivotGrid({
      worksheet: regionWorkSheet,
      component: context.regionAndCompititorGrid.instance
    }).then(() => {
      exportPivotGrid({
        worksheet: processWorkSheet,
        component: context.processAndCompetitorGrid.instance
      })
    }).then(() => {
      exportPivotGrid({
        worksheet: applicationWorkSheet,
        component: context.applicationAndCompetitorGrid.instance
      }).then(() => {
        exportPivotGrid({
          worksheet: asuCapacityWorkSheet,
          component: context.aSUNominalCapacityAndCompetitorGrid.instance
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASU_Awards_By_Competitor.xlsx');
          })
        });
      })
    });
  }

  customizeTooltip(arg: any) {
    return {
      text: `${arg.seriesName} : ${arg.valueText}` + ' mtpd',
    };
  }

  customizeAllBusinessLabel(arg) {
    if (!this.allBusinessColors.has(arg.argumentText)) {
      this.allBusinessColors.set(arg.argumentText, arg.point.getColor());
    }
    return `${arg.argumentText} (${arg.percentText})`;
  }
  customizeSOGBusinessLabel(arg) {
    if (!this.sOGBusinessColors.has(arg.argumentText)) {
      this.sOGBusinessColors.set(arg.argumentText, arg.point.getColor());
    }
    return `${arg.argumentText} (${arg.percentText})`;
  }
  customizeSOEBusinessLabel(arg) {
    if (!this.sOEBusinessColors.has(arg.argumentText)) {
      this.sOEBusinessColors.set(arg.argumentText, arg.point.getColor());
    }
    return `${arg.argumentText} (${arg.percentText})`;
  }
  customizeAllBusinessPoint = (arg: any) => {
    if (this.allBusinessColors.has(arg.data.topCompetitors)) {
      return { color: this.allBusinessColors.get(arg.data.topCompetitors), hoverStyle: { color: this.allBusinessColors.get(arg.data.topCompetitors) } };
    }
  }
  customizeSOGBusinessPoint = (arg: any) => {
    if (this.sOGBusinessColors.has(arg.data.topCompetitors)) {
      return { color: this.sOGBusinessColors.get(arg.data.topCompetitors), hoverStyle: { color: this.sOGBusinessColors.get(arg.data.topCompetitors) } };
    }
  }
  customizeSOEBusinessPoint = (arg: any) => {
    if (this.sOEBusinessColors.has(arg.data.topCompetitors)) {
      return { color: this.sOEBusinessColors.get(arg.data.topCompetitors), hoverStyle: { color: this.sOEBusinessColors.get(arg.data.topCompetitors) } };
    }
  }

}
